import React from 'react';

const SignalProcessing = () => {
  return(
    <article id="signal-processing">
      <h1 className="space-left bold">Signal Processing</h1>
      <section>
        <h2>Heart Rate Extraction <span role="img" aria-label="heart emoji"> ❤️ </span></h2>
        <p>
          Data from the MAX30102 (pulse-oximeter) sensor is polled at a rate of 22 Hz. This raw data
          is then fed through a buffer to generate a rolling average of the infant's heart rate.
          After enough data is collected at startup, the device is able to display a current heart
          rate on the monitor. Prior to use, the user is required to enter the infant’s age, as the
          normal heart rate range varies based on age
          (
          <cite>
            <a href="./data/PediatricHealthDataRange.pdf" target="_blank" rel="noreferrer">Source</a>
          </cite>).
        </p>
        <p>
          One difficulty in setting up the pulse sensor was the variance in the polling frequency,
          as it would vary between transient startup and steady state operation. This would result
          in the calculated heart rate to be inaccurate during the first few seconds after startup
          as the rolling average has not been purged of variations in pulse detection.
        </p>
        <p>
          Another design consideration for the pulse sensor is its need to constantly be in physical
          contact with the skin for a reading to be generated. If it is unable to measure a pulse,
          the rolling average will decrease over time This will trigger the pulse warning on the
          monitor and will require the sensor to be placed back in physical contact with the skin
          for the values to reach the predetermined normal range.
        </p>
      </section>
      <section>
        <h2>Respiratory Rate Extraction <span role="img" aria-label="breathing emoji"> 🌬 </span></h2>
        <article>
          <p>
            The data from the MPU-6050 sensor (accelerometer-gyroscope) is collected to a buffer,
            and through a Fast Fourier Transform (FFT) processed to determine the strongest
            frequency component among the readings, which represents the breathing rate in Hz.
            This breathing rate is converted to breaths per minute for ease of user understanding.
          </p>
          <p>
            Other considerations for the MPU-6050 sensor in tracking breathing include the high
            sensitivity of the MPU-6050. To reduce noise and ensure clarity of signal, both the DC
            component and the high frequencies of the FFT are discarded. If no strong frequency
            component exists among the examined frequencies, then a frequency of 0 is recorded for
            that window.
          </p>
          <p>
            In addition to the high sensitivity of the MPU-6050, the subtleness of chest movement
            while breathing stands out as an important consideration in this device.
            While the MPU-6050 offers high sensitivity in tracking these motions, it is possible
            that no strong frequency may be recorded in a particular FFT window, for which a 0 is
            recorded. A single 0 result before returning to normal frequency value is considered
            possible during normal breathing because of noise and subtleness of breathing and could
            be considered a false positive for cessation of breathing.
          </p>
        </article>
      </section>
      <p className="align-center">
        <strong>*We only tested the prototype on ourselves. No babies are involved in testing this prototype.</strong>
      </p>
      <p className="align-center">
        Please see
        <a href="./data/CSE475Report.pdf" target="_blank" rel="noreferrer"> report </a>
        for more details on implementation.
      </p>
      <p id="to-top">
        <a href="#signal-processing"> Back to Top </a>
      </p>
    </article>
  );
}

export default SignalProcessing;
